import { IconChevronLeft } from '@tabler/icons-react';
import { SidebarPillButton } from './SidebarPillButton';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export function CtaAdditionalAI({ onClick, disabled }: Props) {
  return (
    <SidebarPillButton
      onClick={onClick}
      disabled={disabled}
      icon={<IconChevronLeft size={16} color="var(--mantine-color-orange-6)" />}
      label="Back to Action Mode"
      style={{
        position: 'absolute',
        top: 32,
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    />
  );
}
